import Table from '@shared/components/tables';
import { html } from '@shared/utils/rendering/html';
import {
    GroupCommitteesPaginationConfig,
    GroupCommitteesSortingConfig,
    GroupCommitteesTableColumns,
    GroupCommitteesTableData,
} from '../../../../configs/tables/dashboard/group-committees-table.config';
import { useEffect, useState } from 'preact/hooks';
import { Filter } from '../../../../utils/helpers/static-filter/filter';

const GroupCommittees = () => {
    const [filteredData, setFilteredData] = useState([]);
    const [config, setConfig] = useState({
        columns: GroupCommitteesTableColumns,
        filters: {
            sorting: {
                ...GroupCommitteesSortingConfig,
                callback: (data) => onSortingUpdate(data),
            },
            pagination: {
                ...GroupCommitteesPaginationConfig,
                paginationEvent: (data) => onPaginate(data),
                total: GroupCommitteesTableData.total,
            },
        },
    });

    const onSortingUpdate = (data) => {
        setConfig((prevConfig) => ({
            ...prevConfig,
            filters: {
                ...prevConfig.filters,
                sorting: {
                    ...prevConfig.filters.sorting,
                    sortByColumn: data.sortByColumn,
                    sortByDescending: data.sortByDescending,
                },
            },
        }));
    };

    const onPaginate = (data) => {
        setConfig((prevConfig) => ({
            ...prevConfig,
            filters: {
                ...prevConfig.filters,
                pagination: {
                    ...prevConfig.filters.pagination,
                    paginationData: {
                        ...data,
                    },
                },
            },
        }));
    };

    useEffect(() => {
        setFilteredData(Filter(GroupCommitteesTableData.rows, config));
    }, [config]);

    return html`
        <${Table}
            config=${config}
            data=${{
                rows: filteredData,
                total: GroupCommitteesTableData.total,
                isLoading: false,
            }}
        />
    `;
};

export default GroupCommittees;
